import {
    Component,
    Input,
    Output,
    ViewEncapsulation,
    HostListener,
    OnInit, DestroyRef, inject, OnChanges, SimpleChanges
} from '@angular/core';
import { CfaTab } from '../tabs/cfa-tab';
import { Subject } from 'rxjs';
import { CfaMenuItem } from '../tabs/cfa-menu-item';
import { ISearchObject } from '../models/ISearchObject';
import { FormControl } from '@angular/forms';
import { OverlayContainer } from '@angular/cdk/overlay';
import { SharedFacadeService } from '@emm/shared/services/shared-facade.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

@Component({
       selector: 'cfa-toolbar',
    templateUrl: './toolbar.html',
    styleUrls: ['../../styles/styles.scss', './toolbar.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CfaToolbar implements OnInit, OnChanges {
    @Input() ignoreContainerPadding = false;
    @Input() appName: string;
    @Input() mobileTitle: string;
    @Input() showHamburgerMenu = false;
    @Input() showDropShadow = false;
    @Input() cfaTabs: CfaTab[] = [];
    @Input() cfaMenuItems: CfaMenuItem[] = [];
    @Input() userName: string;
    @Input() activeSearchObject: ISearchObject;
    @Input() searchObjects: ISearchObject[] = [];
    @Input() navSearchObjectName = 'Stores';
    @Input() navSearchFilterFunction: (search: string, objects: ISearchObject[]) => ISearchObject[];
    @Input() cartEnabled = false;
    @Input() useMaterialTheme = false;

    @Input() showMenuPane = false;
    @Input() menuPaneCalculatedDistance = -100;

    @Input() customHeader = false;

    expandHamburgerMenu = false;
    expandPopupMenu = false;
    searchReady = false;

    windowIsLarge = window.innerWidth >= 992;

    @Output() menuClicked = new Subject<void>();
    @Output() homeClicked = new Subject<void>();
    @Output() signOutClicked = new Subject<void>();
    @Output() tabSelected: Subject<number> = new Subject<number>();
    @Output() storeSelected: Subject<string> = new Subject<string>();

    private readonly destroyRef: DestroyRef = inject(DestroyRef);


    constructor(private overlay: OverlayContainer, private sharedFacadeService: SharedFacadeService) { }

    ngOnInit() {}

    ngOnChanges(changes: SimpleChanges) {
        this.sharedFacadeService.init();
    }

    clickHome() {
        this.homeClicked.next();
    }

    clickMenu() {
        this.expandPopupMenu = !this.expandPopupMenu;
        this.menuClicked.next();
    }

    clickHamburger() {
        this.expandHamburgerMenu = !this.expandHamburgerMenu;
        this.menuClicked.next();
    }

    clickStore() {
        this.searchReady = !this.searchReady;
    }

    clickSignOut() {
        this.signOutClicked.next();
    }

    selectStore(obj: ISearchObject) {
        this.activeSearchObject = obj;
        this.storeSelected.next(obj.id);
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.windowIsLarge = event.target.innerWidth >= 992;
    }
}
